<template lang="html">

  <section class="politica-de-cookies margin-menu wrapper">
    <div class="legal container">
      <h1>Política de cookies</h1>
      <p>LA FUNDACION TOMAS PASCUAL Y PILAR GÓMEZ-CUÉTARA ha desarrollado la presente Política de Cookies con la
        finalidad de informar a los usuarios del sitio web http://www.fundaciontomaspascualypilargomez-cuetara.org de
        los aspectos precisos respecto de la instalación y uso de cookies en el sitio web. </p>
      <p>Además de la presente Política de Cookies, también resulta de aplicación a la gestión de su privacidad que
        realizamos nuestra Política de Privacidad, que complementa a la presente Política de Cookies y que puede
        consultar en el presente Sitio Web para obtener más información sobre protección de datos.</p>

      <h2>Introducción.</h2>
      <p>Con la finalidad de ofrecer los servicios y funcionalidades del presente Sitio Web CALIDAD PASCUAL, S.A.U
        utiliza diferentes tipologías de cookies, propias y de terceros, tal como se informa en la consola de
        configuración y gestión de cookies del presente Sitio Web.</p>

      <h2>¿Qué son las cookies?</h2>
      <p>Una cookie es un fichero que se descarga en su dispositivo al acceder a determinadas páginas web. Las cookies
        permiten a una página web, entre otras cosas, el propio funcionamiento de la página web y la comprobación de
        aspectos esenciales, como la identidad del usuario en caso de peticiones individualizadas.</p>

      <p>Las cookies pueden afectar a la privacidad de los usuarios mismos, por este motivo, queremos ofrecerle la
        información necesaria sobre la tipología de cookies utilizada en el Sitio Web, para que tenga plena capacidad de
        decisión en relación al uso de las mismas y a la protección de su privacidad.</p>

      <p>En este sentido, le informamos de que para poder utilizar la totalidad de servicios y funcionalidades del Sitio
        Web es necesario habilitar las cookies en el navegador de Internet.</p>

      <h2>¿Qué cookies utilizamos? </h2>
      <p>El presente Sitio Web ofrece a sus usuarios una consola de configuración de cookies mediante la que el usuario
        puede gestionar sus preferencias en relación con la instalación o no de cookies en su equipo, así como obtener
        información detallada sobre las tipologías de cookies que utiliza el presente Sitio Web y las características de
        cada una de las cookies utilizadas.</p>

      <p>La consola de configuración de cookies se muestra al usuario con su primera visita al Sitio Web y además, es
        posible acceder a la misma desde aquí.</p>

      <h2>¿Quién utiliza las cookies?</h2>
      <p>La información que se recaba a través de las cookies de una página web puede ser utilizada tanto por el titular
        de la página web, como por un tercero que preste un servicio al titular. </p>

      <p>En este sentido, la información de las cookies utilizadas en el presente Sitio Web es tratada por CALIDAD
        PASCUAL, S.A.U. como editor de la página web, así como por terceros que prestan servicios al editor.</p>

      <h2>¿Cómo visualizar las cookies?</h2>
      <p>Todos los navegadores ofrecen al usuario la posibilidad de buscar y visualizar las cookies que instala un
        determinado sitio web, obtener información relativa a la duración de las mismas y la posibilidad de eliminarlas,
        tal y como se indica en el siguiente apartado. </p>

      <p>A continuación, se muestran una serie de enlaces informativos sobre esta cuestión de los navegadores de
        Internet más utilizados:</p>

      <ul>
        <li>• Google Chrome: https://support.google.com/chrome/answer/95647?hl=es </li>
        <li>• Mozilla Firefox: https://support.mozilla.org/es/kb/Borrar%20cookies </li>
        <li>• Internet Explorer:
          https://support.microsoft.com/es-es/help/278835/how-to-delete-cookie-files-in-internet-explorer </li>
        <li>• Safari: https://www.apple.com/legal/privacy/es/cookies/</li>
      </ul>


      <h2>¿Cómo eliminar las cookies?</h2>
      <p>Para restringir o bloquear las cookies, deberá modificar la configuración del navegador que utilices en su
        terminal, ya sea ordenador, smartphone o tablet. </p>

      <p>Con carácter general, los navegadores ofrecen las siguientes opciones de configuración en relación a la
        instalación de cookies:</p>

      <ul>
        <li>• Que el navegador rechace todas las cookies y, por lo tanto, que no se instale ninguna cookie de ninguna
          página web en su terminal.</li>

        <li>• Que el navegador avise antes de que se produzca la instalación de la cookie para que decida si acepta o no
          la instalación de la misma.</li>

        <li>• Que el navegador únicamente rechace las cookies de terceros de los sitios web que visita, pero no las
          utilizadas por el sitio web por el que navega.</li>

        <li>• La opción de navegación en modo privado mediante la cual las cookies se instalan en el terminal, pero se
          eliminan de manera automática cuando finalizas la navegación por la página web. En los siguientes enlaces
          puede obtener información sobre la navegación en modo privado en los navegadores de Internet más utilizados:
        </li>
      </ul>

      <ul>
        <li>• Google Chrome: https://support.google.com/chrome/answer/95464?hl=es </li>
        <li>•Mozilla Firefox:
          https://support.mozilla.org/es/kb/navegacion-privada-navega-en-la-web-sin-guardar-in?redirectlocale=en-US&as=u&redirectslug=Private+Browsing&utm_source=inproduct
        </li>
        <li>• Internet Explorer: https://support.microsoft.com/es-es/help/4026200/microsoft-edge-browse-inprivate</li>
        <li>• Safari: https://support.apple.com/es-es/guide/safari/ibrw1069/mac</li>
      </ul>


    </div>
  </section>

</template>

<script lang="js">
  export default {
    name: 'politica-de-cookies',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped lang="scss">
  .politica-de-cookies {}
</style>


// WEBPACK FOOTER //
// src/components/views/politica-de-cookies.vue